import { Component, ViewEncapsulation } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'ls-progress-spinner-atom',
  standalone: true,
  imports: [ProgressSpinnerModule],
  templateUrl: './progress-spinner-atom.component.html',
  styleUrl: './progress-spinner-atom.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ProgressSpinnerAtomComponent {}
